import BaseComponent from '../base-component/base-component'
import { hideElement, showElement } from '../../utils/dom'
import { Nullable } from '../../types/common'
import { getTransitionDuration } from '../../utils/utils'

class List extends BaseComponent {
  itemSelector: string
  expandBtnSelector: string
  collapseBtnSelector: string
  visibleItemSelector: string
  hiddenItemSelector: string
  expandBtn: Nullable<HTMLElement>
  collapseBtn: Nullable<HTMLElement>
  initialHeight: number
  maxHeight: number
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.itemSelector = `[data-list-item]`
    this.expandBtnSelector = `list-btn[data-trigger="expand"]`
    this.collapseBtnSelector = `list-btn[data-trigger="collapse"]`
    this.visibleItemSelector = `${this.itemSelector}:not(.hidden)`
    this.hiddenItemSelector = `${this.itemSelector}.hidden`

    this.expandBtn = this.querySelector(this.expandBtnSelector)
    this.collapseBtn = this.querySelector(this.collapseBtnSelector)

    this.styles = getComputedStyle(this)
  }

  setInitialHeight(): void {
    this.initialHeight = this.offsetHeight

    this.style.maxHeight = `${this.initialHeight}px`
  }

  setMaxHeight(): void {
    this.maxHeight = this.scrollHeight

    this.style.maxHeight = `${this.maxHeight}px`
  }

  collapse = (): void => {
    this.hideItems()

    hideElement(this.collapseBtn)
    showElement(this.expandBtn)
  }

  expand = (): void => {
    if (!this.initialHeight) {
      this.setInitialHeight()
    }

    this.showItems()

    this.tryHideExpandBtn()
    showElement(this.collapseBtn)

    this.setMaxHeight()
  }

  hideItems(): void {
    const visibleItems = this.querySelectorAll(this.visibleItemSelector)

    this.style.maxHeight = `${this.initialHeight}px`

    setTimeout(() => {
      visibleItems.forEach((node, index) => {
        const initialCount = this.dataset.initialCount
          ? +this.dataset.initialCount
          : 0
        const isOverIntitialCount = index + 1 > +initialCount

        if (isOverIntitialCount) {
          hideElement(node)
        }
      })
    }, getTransitionDuration(this.styles))
  }

  showItems(): void {
    const hiddenItems = this.querySelectorAll(this.hiddenItemSelector)

    hiddenItems.forEach((node, index) => {
      const showCount = this.dataset.showCount ? this.dataset.showCount : 0
      const isLessShowCount = index + 1 < +showCount

      if (isLessShowCount) {
        showElement(node)
      }
    })

    this.style.maxHeight = `${this.maxHeight}px`
  }

  tryHideExpandBtn(): void {
    const hiddenItems = this.querySelectorAll(this.hiddenItemSelector)

    if (hiddenItems.length === 0) {
      hideElement(this.expandBtn)
    }
  }
}

export default List
